/*
  ============================================================
  cart-auto-gift.js — Brinde automático por produto-gatilho
  ------------------------------------------------------------
  Regra: quantidade da linha de brinde = ratio x unidades de
  gatilho no carrinho, SEMPRE — o cliente não escolhe nem remove.
  Config (gatilhos/brinde/ratio) vem do snippet cart-auto-gift.liquid.

  - GANCHO DE FETCH (mesmo padrão do cart-gifts-v2b.js): intercepta
    as respostas /cart*.js que o tema lê, reconcilia a quantidade
    do brinde via API interna e devolve o carrinho JÁ CORRIGIDO —
    o tema re-renderiza o drawer a partir desse JSON, então a
    linha aparece/ajusta/some sem refresh. Remoção pelo cliente
    (ex.: página /cart) é desfeita na reconciliação seguinte.
  - Reutiliza o header interno do cart-gifts ("x-cart-gifts-internal"):
    os ganchos dos DOIS módulos ignoram chamadas internas de ambos,
    sem loops. Este script carrega DEPOIS do cart-gifts-v2b.js (ordem
    dos renders na seção cart-drawer) — o gancho daqui embrulha o de
    lá e recebe a resposta já reconciliada pela régua de brindes.
  - IDENTIDADE: linha com a propriedade VISÍVEL "Cortesia" (nome
    proibido: "Brinde" — o CSS da régua oculta essas linhas). A
    linha paga do mesmo produto (sem propriedade) não é tocada e
    NÃO conta como gatilho.
  - Linhas de brinde da régua (propriedade "Brinde") não contam
    como gatilho mesmo se um gatilho virar brinde da régua um dia.
  - Quem zera o preço é o BXGY automático do admin. SALVAGUARDA:
    se a linha de brinde vier COBRADA (desconto pausado/combinação
    errada) e não houver compra paga do mesmo produto no carrinho,
    remove o brinde e desliga o módulo na sessão — nunca cobrar o
    cliente pelo brinde.
  - Sem estoque: se a variante do brinde está indisponível no
    render, o alvo vira 0 (remove linhas órfãs de sessões antigas
    para não travar o checkout). Falha de API congela o módulo.
  ============================================================
*/
(function () {
  'use strict';
  if (window.__cartAutoGiftLoaded) return;
  window.__cartAutoGiftLoaded = true;

  var LOG = '[BrindeAuto]';
  var HDR = 'x-cart-gifts-internal';
  var PROP = 'Cortesia';
  var PROP_VAL = 'Brinde';
  var RULER_PROP = 'Brinde'; // propriedade das linhas da régua de brindes

  var cfgEl = document.getElementById('cart-auto-gift-data');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) {
    console.error(LOG, 'config inválida:', e);
    return;
  }
  var TRIGGERS = new Set(CFG.triggers || []);
  var GIFT = CFG.gift || {};
  var RATIO = CFG.ratio || 1;
  if (!TRIGGERS.size || !GIFT.variantId) return;

  var giftAvailable = !!GIFT.available;
  var frozen = false;         // falha de API: congela (não mexe mais no carrinho)
  var discountBroken = false; // BXGY não zerou: força alvo 0
  var lastCart = null;

  // ---------- Gancho global de fetch ----------
  var nativeFetch = window.fetch.bind(window);

  function pathOf(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return url.split('?')[0];
  }
  function isInternal(init) {
    return !!(init && init.headers && (init.headers[HDR] || (init.headers.get && init.headers.get(HDR))));
  }

  window.fetch = async function (input, init) {
    var res = await nativeFetch(input, init);
    try {
      if (!isInternal(init) && !frozen) {
        var p = pathOf(input);
        if (/\/cart(\.js|\/change\.js|\/update\.js|\/clear\.js)$/.test(p)) {
          var cart = await res.clone().json();
          if (cart && Array.isArray(cart.items)) {
            var fixed = await reconcile(cart);
            if (fixed) {
              return new Response(JSON.stringify(fixed), {
                status: 200,
                headers: { 'Content-Type': 'application/json' },
              });
            }
          }
        }
      }
    } catch (e) { console.warn(LOG, 'gancho de fetch falhou (seguindo normal):', e); }
    return res;
  };

  var internalGet = function (url) { return nativeFetch(url, { headers: { 'x-cart-gifts-internal': '1' } }); };
  var internalPost = function (url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-cart-gifts-internal': '1' },
      body: JSON.stringify(body),
    });
  };

  function syncExtras(cart) {
    try { if (cart && window.__cartExtrasSync) window.__cartExtrasSync(cart); } catch (e) { /* segue */ }
  }
  function updateHeaderCount(cart) {
    try {
      var n = cart.item_count;
      document.querySelectorAll('[data-items-count]').forEach(function (el) {
        el.textContent = '(' + n + (n === 1 ? ' item' : ' itens') + ')';
      });
    } catch (e) { /* segue */ }
  }

  // ---------- Regras ----------
  function isGiftLine(item) {
    return item.variant_id === GIFT.variantId
      && !!(item.properties && item.properties[PROP] != null);
  }
  // Gatilho = linha PAGA de produto da lista (linhas de brinde — desta
  // mecânica ou da régua — nunca contam).
  function triggerUnits(cart) {
    return cart.items.reduce(function (s, i) {
      if (!TRIGGERS.has(i.product_id)) return s;
      if (i.properties && (i.properties[PROP] != null || i.properties[RULER_PROP] != null)) return s;
      return s + i.quantity;
    }, 0);
  }

  // ---------- Reconciliação ----------
  var reconciling = false;

  async function reconcile(cart) {
    if (reconciling || frozen) return null;
    reconciling = true;
    try {
      var lines = cart.items.filter(isGiftLine);
      var current = lines.reduce(function (s, l) { return s + l.quantity; }, 0);

      // SALVAGUARDA: brinde cobrado sem compra paga do mesmo produto no
      // carrinho => o BXGY não está zerando (pausado? combinação? datas?).
      // Remove tudo e desliga — nunca cobrar o cliente pelo brinde.
      if (!discountBroken && lines.length) {
        var hasPaidGift = cart.items.some(function (i) {
          return i.product_id === GIFT.productId && !isGiftLine(i);
        });
        var charged = lines.some(function (l) { return l.final_line_price > 0; });
        if (charged && !hasPaidGift) {
          discountBroken = true;
          console.error(LOG, 'desconto BXGY não zerou o brinde — removendo e desligando. Confira o desconto automático no admin (ativo? combina com descontos de produto/pedido?).');
        }
      }

      var target = 0;
      if (giftAvailable && !discountBroken) target = RATIO * triggerUnits(cart);

      if (current === target) { decorate(cart); return null; }

      // Uma linha só, quantidade = alvo; duplicatas (estados estranhos)
      // são zeradas. Sempre pela CHAVE da linha de brinde — a linha paga
      // do mesmo produto nunca é tocada.
      var ops = false;
      var updates = {};
      lines.forEach(function (l, n) {
        var want = n === 0 ? target : 0;
        if (l.quantity !== want) updates[l.key] = want;
      });
      if (Object.keys(updates).length) {
        var upRes = await internalPost('/cart/update.js', { updates: updates });
        if (!upRes.ok) throw new Error('update falhou: ' + upRes.status);
        ops = true;
      }
      if (!lines.length && target > 0) {
        var props = {};
        props[PROP] = PROP_VAL;
        var addRes = await internalPost('/cart/add.js', {
          items: [{ id: GIFT.variantId, quantity: target, properties: props }],
        });
        if (!addRes.ok) throw new Error('add falhou: ' + addRes.status);
        ops = true;
      }
      if (!ops) { decorate(cart); return null; }

      var newCart = await internalGet('/cart.js').then(function (r) { return r.json(); });
      decorate(newCart);
      syncExtras(newCart);
      return newCart;
    } catch (e) {
      // Falha de API (ex.: estoque acabou no meio da sessão): congela o
      // módulo — melhor uma sessão sem brinde do que um loop de erros.
      frozen = true;
      console.error(LOG, 'reconcile falhou — módulo congelado até o reload:', e);
      return null;
    } finally { reconciling = false; }
  }

  // ---------- Decoração da linha no drawer ----------
  // Trava a linha (classe esconde remover/qty via CSS) e troca o preço
  // "R$ 0,00" por "Grátis". Roda após cada reconcile e a cada re-render
  // da lista (MutationObserver) — o template JS do bundle recria as
  // linhas e desfaz a troca.
  function decorate(cart) {
    var c = cart || lastCart;
    if (!c) return;
    lastCart = c;
    var keys = {};
    c.items.forEach(function (i) { if (isGiftLine(i)) keys[i.key] = true; });
    var apply = function () {
      document.querySelectorAll('cart-item[data-key]').forEach(function (el) {
        var on = !!keys[el.getAttribute('data-key')];
        el.classList.toggle('cart-item--auto-gift', on);
        if (on) {
          var v = el.querySelector('.product-price__current-value');
          if (v && v.textContent !== 'Grátis') v.textContent = 'Grátis';
        }
      });
    };
    apply();
    requestAnimationFrame(apply);
  }

  function observeItemsList() {
    var list = document.querySelector('cart-component cart-items-list')
      || document.querySelector('cart-component .cart-items--list');
    if (!list || typeof MutationObserver === 'undefined') return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        decorate();
      }, 30);
    }).observe(list, { childList: true, subtree: true });
  }

  // ---------- Init ----------
  // Reconciliação inicial fora de um request do tema: se mexeu no
  // carrinho (ex.: carrinho persistido de outra sessão), atualiza
  // contador e resumo manualmente — o tema não viu essa mudança.
  (async function init() {
    observeItemsList();
    try {
      var cart = await internalGet('/cart.js').then(function (r) { return r.json(); });
      var fixed = await reconcile(cart);
      if (fixed) updateHeaderCount(fixed);
      else decorate(cart);
      console.info(LOG, 'carregado — gatilhos:', TRIGGERS.size, '| ratio:', RATIO, '| brinde disponível:', giftAvailable);
    } catch (e) { console.error(LOG, 'init falhou:', e); }
  })();
})();
